import { render, staticRenderFns } from "./SchoolInfrastructurePage.vue?vue&type=template&id=36652908&scoped=true"
import script from "./SchoolInfrastructurePage.vue?vue&type=script&lang=js"
export * from "./SchoolInfrastructurePage.vue?vue&type=script&lang=js"
import style0 from "./SchoolInfrastructurePage.vue?vue&type=style&index=0&id=36652908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36652908",
  null
  
)

export default component.exports